
let Config={
  //UAT
  // WSS:"wss://mw.mjhero.cn:/web_test",
  // HTTP:"http://mw.mjhero.cn:9588/",

  //RELEASE
  WSS:"wss://mw.mjhero.cn:/web",
  HTTP:"https://mw.mjhero.cn/",
};

export default Config



// WEBPACK FOOTER //
// ./src/view/config.js